import * as React from "react";
import styled from "@mui/material/styles/styled";
import { SupportingWeakeningWidget } from "fe-web-components/supportingWeakening/supportingWeakeningWidget";
import { FONT_FAMILY_HEB, FONT_FAMILY_LATIN } from "./consts/sizeConsts";
import { useCalculateFindingPredictives } from "fe-common/utils/FindingStrengthCalculator";
import { usePatient } from "../state/patientContext";
import { RouteComponentProps, useHistory, useParams } from "react-router";
import { PatientColorMap } from "../layout/patientColorMap";
import { IconButton } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { PatientRoute } from "../PatientRoutes/PatientRoute";
import { onRtl } from "fe-web-components/rtl/rtlStyles";

//region [[ Styles ]]

const MoreInfoContainerView = styled("div")(({ theme }) => ({
  padding: "20px",
}));

const TopArea = styled("div")(({ theme }) => ({
  display: "flex",

  alignItems: "center",
}));

const DescriptionArea = styled("div")(({ theme }) => ({
  padding: "20px",
}));

const FeatureTitle = styled("div")(({ theme }) => ({
  color: PatientColorMap.Primary,
  fontSize: "18px",

  fontWeight: "bold",
}));

const FeatureDescription = styled("div")(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "21px",
}));

const BackButtonIcon = styled(IconButton)(({ theme }) => ({}));

const BackIcon = styled(KeyboardArrowLeftIcon)(() => ({
  color: "black",
  fontSize: "32px",
}));

const ExplanationContainer = styled("div")({
  padding: "20px",

  fontFamily: FONT_FAMILY_LATIN,
  ...onRtl({
    fontFamily: FONT_FAMILY_HEB,
  }),

  display: "flex",
  flexDirection: "column",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface MoreInfoContainerProps
  extends RouteComponentProps<{ id?: string }> {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const MoreInfoContainer = ({ ...props }: MoreInfoContainerProps) => {
  const { conversationDDResult } = usePatient();

  const history = useHistory();

  const { id } = useParams<{ id: string }>();

  const ddClusters = conversationDDResult.ddClusters;

  const getFindingsStrength = useCalculateFindingPredictives(
    conversationDDResult && conversationDDResult.crs.length > 0
      ? conversationDDResult.crs
      : null,
  );

  const cluster = [...ddClusters.top, ...ddClusters.others].find(
    (cr) => cr.id === id,
  );

  const onBack = () => {
    history.push("/" + PatientRoute.Result);
  };

  return (
    <MoreInfoContainerView>
      <TopArea>
        <BackButtonIcon onClick={onBack}>
          <BackIcon />
        </BackButtonIcon>
        <FeatureTitle>{cluster.title.feature.shortname}</FeatureTitle>
      </TopArea>

      <DescriptionArea>
        <FeatureDescription>
          {cluster.title.feature?.description?.text}
        </FeatureDescription>
      </DescriptionArea>

      <ExplanationContainer>
        <SupportingWeakeningWidget
          findingsStrength={getFindingsStrength(cluster.cr as any)}
          hideWeakening={true}
        />
      </ExplanationContainer>
    </MoreInfoContainerView>
  );
};
